"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MediaServicesBlurIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M4.889 4H12v8H4V4.889C4 4.398 4.398 4 4.889 4"/><path d="M4 12h8v8H4.889A.89.89 0 0 1 4 19.111z" opacity=".4"/><path d="M12 4h7.111c.491 0 .889.398.889.889V12h-8z" opacity=".55"/><path d="M12 12h8v7.111a.89.89 0 0 1-.889.889H12z" opacity=".75"/></g></svg>`
}, props));
MediaServicesBlurIcon.displayName = 'MediaServicesBlurIcon';
var _default = exports.default = MediaServicesBlurIcon;